import { takeLatest, call, put } from 'redux-saga/effects'
import * as fromActions from '../../actions/courses.action'
import downloadCoursesEvaluations from '../../../api/courses/DownloadEvaluations'
import { SuccessToast, ErrorToast } from 'components/ui/toast/toastsTemplates'
import I18n from 'i18n'
import { prepareSearch } from 'helpers/courseSearch.helper'

async function downloadCourseEvaluations(allSelected: boolean, ids: any[], q: any) {
  return downloadCoursesEvaluations(allSelected, ids, q)
}

function* coursesDownloadEvaluationsEffectSaga(actions: any) {
  try {
    const { selectedRows, allSelected, params } = actions.payload
    const { searchText, usersFilter, fastFilters, areaId } = params

    const q = allSelected
      ? prepareSearch(searchText, usersFilter, fastFilters, areaId)
      : {}

    const { data } = yield call(downloadCourseEvaluations, allSelected, selectedRows, q)
    yield put(fromActions.Actions.coursesDownloadEvaluationsSuccess(data))
    SuccessToast(I18n.t('administration.toastMessages.downSuccess'))
  } catch (error) {
    ErrorToast(I18n.t('administration.toastMessages.downloadError'))
    console.error(error)
  }
}

export function* coursesDownloadEvaluationsWatcherSaga() {
  yield takeLatest(fromActions.COURSES_DOWNLOAD_EVALUATIONS, coursesDownloadEvaluationsEffectSaga)
}
